import { render, staticRenderFns } from "./ServiceOther.vue?vue&type=template&id=87a5635a&scoped=true"
import script from "./ServiceOther.vue?vue&type=script&lang=js"
export * from "./ServiceOther.vue?vue&type=script&lang=js"
import style0 from "./ServiceOther.vue?vue&type=style&index=0&id=87a5635a&prod&lang=scss&scoped=true"
import style1 from "./ServiceOther.vue?vue&type=style&index=1&id=87a5635a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a5635a",
  null
  
)

export default component.exports